import { addStyles } from 'ethcss'
import item from 'blocks.simple/item/item.jcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { indents } from 'blocks.app/config'
import { defaultThemeStyles } from '../editor.theme'
import { mediaCSS, textSizes } from 'theme/media'
import { colors, IStyles } from '../../../theme'

const editorTemplatesStyles: IStyles = {
    templatesContainer: {
        position: 'relative',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        background: colors.white,
        zIndex: 3,
        padding: '0 21px 14px 21px',
    },
    headerLeft: {
        width: '58%',
    },
    headerRight: {
        display: 'flex',
        alignItems: 'center',
        width: '40%',
    },
    deleteAll: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 40,
        height: 41,
        background: 'white',
        borderRadius: '0 6px 6px 0',
        borderTop: `1px solid ${colors.cloud}`,
        borderRight: `1px solid ${colors.cloud}`,
        borderBottom: `1px solid ${colors.cloud}`,

        [mediaCSS.tab]: {
            height: 33,
        },
    },
    scrollable: {
        height: 'calc(100vh - 106px)',
        overflow: 'auto',
        paddingTop: 40,

        [mediaCSS.tab]: {
            height: 'calc(100vh - 136px)',
        },

        [mediaCSS.mob]: {
            height: 'calc(100vh - 90px)',
        },
    },
    wrapper: {
        ...grid.row,
        ...grid.pr_md,
    },
    cell: {
        ...grid.col3,
        ...grid.pl_md,
        ...grid.pt_md,
    },
    cellInner() {
        return {
            ...grid.col,
            cursor: 'pointer',
            position: 'relative',
            [`&:hover .${this.cellRect}`]: {
                ...item.shadowButton,
            },
            [`&:hover .${this.delete}`]: {
                visibility: 'visible',
            },
            [`&:hover .${this.checkWrapper}`]: {
                opacity: 1,
            },
        }
    },
    cellRect: {
        backgroundColor: `var(--var-module-editor-component-templates-style-template, ${defaultThemeStyles.template})`,
    },
    title: {
        ...grid.w100,
        ...grid.mt_micro,
        textAlign: 'center',
        fontSize: textSizes.mini,
        color: `var(--var-module-editor-component-templates-style-template-title, ${defaultThemeStyles['template-title']})`,
    },
    area: {
        position: 'absolute',
        border: `1px solid var(--var-module-editor-component-templates-style-template-border, ${defaultThemeStyles['template-border']})`,
    },
    delete: {
        position: 'absolute',
        visibility: 'hidden',
        top: 6,
        right: 6,
    },
    linked: {
        position: 'absolute',
        bottom: 20,
        left: 2,
        zIndex: 1,
    },
    checkWrapper: {
        position: 'absolute',
        left: 6,
        top: 6,
        zIndex: 2,
        opacity: 0,
        scale: 0.8,

        [mediaCSS.tab]: {
            opacity: 1,
            right: 0,
        },
    },
    dropdownFilter: {
        borderRadius: '6px',
        border: `1px solid ${colors.cloud}`,

        [mediaCSS.tab]: {
            padding: 7,
            fontSize: 12,
        },
    },
    fullWidth: {
        width: 'calc(100% - 40px)',
    },
    dropdownBtn: {
        borderRadius: '6px 0 0 6px',
        border: `1px solid ${colors.cloud}`,
        width: '100%',

        [mediaCSS.tab]: {
            padding: 7,
            fontSize: 12,
        },
    },
    deleteModal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(0,0,0,0.7)',
        zIndex: 2000,
    },
    deleteModalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        borderRadius: 20,
        minWidth: 560,
        maxWidth: 560,
        padding: 30,
    },
    deleteModalTitle: {
        fontSize: 22,
        textAlign: 'center',
    },
    deleteModalText: {
        textAlign: 'center',
        marginTop: 14,
    },
    controls: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '30px auto 0 auto',
        maxWidth: 210,
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        width: 100,
    },
}

addStyles(editorTemplatesStyles)
export default editorTemplatesStyles
